import axios from "axios";
const getVariantMetafield = API_URL.getVariantMetafield;

export const storeFront = async (handle) => {
   
    const producthandle = handle;
    const storeFrontApi = "7f73bc5598f7ee6322ab39e4dc406c32";
    const request = {
      "handle": `${producthandle}`
    }
    try {
      const response = await axios.post(getVariantMetafield, JSON.stringify(request));
      return response.data;
    } catch (error) {
      throw new Error("Failed to get variant metafield.");
    }

}



